import React from 'react'
import css from './Content.css'
import AllRoutes from './AllRoutes'

const Content = () => {
  return (
    <div className='content'>
      <h1>Content</h1>
      <AllRoutes/>
    </div>
  )
}

export default Content
